import React from 'react';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { Typography } from 'src/ui/common/atoms/typography';
import TooltipComponent from 'src/ui/common/organisms/tooltip/tooltip.component';
import { StyledBadge } from './badge.styles';

export interface BadgeProps {
    type: 'message' | 'warning' | 'success' | 'error';
    text: string;
    hintText?: string;
}

export const Badge: React.FC<BadgeProps> = ({ type, text, hintText, ...rest }) => (
    <StyledBadge
        onClick={(e) => {
            e.stopPropagation();
        }}
        {...rest}
        type={type}
    >
        <Typography medium size="xs" variant="title">
            {text}
        </Typography>
        {hintText && (
            <TooltipComponent
                position="bottom"
                hasTooltipInteraction
                themeColor="light"
                content={<Typography size="xxs">{hintText}</Typography>}
            >
                <SvgIcon variant="regular" width={16} height={16} icon="info" />
            </TooltipComponent>
        )}
    </StyledBadge>
);

Badge.displayName = 'Badge';